
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand",
      function () {
        return require("private-next-pages/brand/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand"])
      });
    }
  